import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "acPhoneInputNew" }
const _hoisted_2 = {
  key: 0,
  class: "acPhoneInputNew_label"
}
const _hoisted_3 = {
  key: 0,
  class: "acPhoneInputNew_note"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label || _ctx.note)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.note)
            ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_ctx.note), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_vue_tel_input, {
      id: _ctx.id,
      "model-value": _ctx.value,
      mode: "auto",
      "auto-format": true,
      "preferred-countries": _ctx.preferredCountries,
      "default-country": _ctx.defaultCountry,
      "dropdown-options": _ctx.dropdownOptions,
      "input-options": _ctx.inputOptions,
      "style-classes": "acPhoneInputNew_wrapper",
      onOnInput: _ctx.onInput,
      onValidate: _ctx.onValidate,
      onCountryChanged: _ctx.onCountryChanged,
      "valid-characters-only": true
    }, null, 8, ["id", "model-value", "preferred-countries", "default-country", "dropdown-options", "input-options", "onOnInput", "onValidate", "onCountryChanged"]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "acPhoneInputNew_error",
          innerHTML: _ctx.error
        }, null, 8, _hoisted_4))
      : (_ctx.hit)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "acPhoneInputNew_hit",
            innerHTML: _ctx.hit
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true)
  ]))
}